import { render, staticRenderFns } from "./CustomerCreditNote.vue?vue&type=template&id=4417b860&lang=pug&"
import script from "./CustomerCreditNote.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditNote.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerCreditNote.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {
  VCard,
})
